// DiagiaExample — the sample scoping sheet, in the visitor's language.
// Replaces the old standalone /diagnostic example entry point: everything
// diagnostic-related now lives under /diagia.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import DiagnosticDoc from '../../diagnostic/DiagnosticDoc';
import { getExampleDiagnostic } from '../../diagnostic/exampleMarkdown';

export default function DiagiaExample() {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  return (
    <DiagnosticDoc
      markdown={getExampleDiagnostic(i18n.language)}
      onBack={() => navigate('/diagia')}
    />
  );
}
